import { render } from "./Register.vue?vue&type=template&id=4f3efb5b&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=4f3efb5b&lang=css"
import "./Register.vue?vue&type=style&index=1&id=4f3efb5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3efb5b"]])

export default __exports__